<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <div v-if="loan_schedule!=null">
                        <v-menu v-if="!loading&&hasApproverRights" left v-model="menu_status" offset-y :disabled="disabledForApprover"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(loan_schedule.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(loan_schedule.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense >
                                <v-list-tile v-show="hasApproverRights&&processed_status" @click="setToPaid" :key="2" title="Set to Paid">
                                    <v-list-tile-title small>Set to Paid</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            
            <!-- details -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Payment Details</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Requested For :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <v-chip @click="viewUserProfile(loan_schedule, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(loan_schedule.userId)"></v-img>
                                        </v-avatar>
                                        {{loan_schedule.name}} 
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Due On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{loan_schedule.dueOn | moment('MMM DD, YYYY')}} 
                                </v-flex>  
                            </v-layout>      
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Amount Due :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    ₱{{numFormat.formatNumber(loan_schedule.amountDue)}} 
                                </v-flex>  
                            </v-layout>  
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Status :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{commonfn.getStatusDescription(loan_schedule.status)}} 
                                </v-flex>  
                            </v-layout>    
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Processed On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <span v-if="loan_schedule.processedOn!=null">{{loan_schedule.processedOn | moment('MMM DD, YYYY')}}</span>
                                    <span v-else>Not Available</span>
                                </v-flex>  
                            </v-layout>
                            <v-layout v-if="loan_schedule.processedOn!=null" row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Processed By :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <v-chip style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="loan_schedule.processedByAvatar"></v-img>
                                        </v-avatar>
                                        {{loan_schedule.processedByName}} 
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Paid On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <span v-if="loan_schedule.paidOn!=null">{{loan_schedule.paidOn | moment('MMM DD, YYYY')}}</span>
                                    <span v-else>Not Available</span>
                                </v-flex>  
                            </v-layout>
                            <v-layout v-if="loan_schedule.paidOn!=null" row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Paid By :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <v-chip style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="loan_schedule.processedByAvatar"></v-img>
                                        </v-avatar>
                                        {{loan_schedule.processedByName}} 
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>      
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedLoanScheduleId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedLoanScheduleId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'   //for refactor
import loansApi from '@/api/loans'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import { hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default {     
    name: 'Loans',
    metaInfo: {
        title: 'Loan Payments Schedule',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Loans' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            loading_status: false,
            menu_status: false,
            my_profile: null,
            loan_schedule: null
        }
    },
    methods: {
        async setToPaid() {
            try {
                this.loading_status = true
                var data = {
                    loanScheduleId : this.selectedLoanScheduleId
                }
                const response = await loansApi.setToPaid(data)
                if (response.status == 200) {
                    this.getScheduleDetails(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        async getScheduleDetails(show_loading) {
            try {
                this.loading = show_loading
                const response = await loansApi.getSchedule(this.selectedLoanScheduleId)
                if (response.status == 200) {
                    this.loan_schedule = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getScheduleDetails(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        this.commonfn = commonfn
        this.numFormat = numFormat
        this.awsS3Helper = awsS3Helper
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payment Schedule Details'
        })

        this.getScheduleDetails(true)
    },
    computed: {
        selectedLoanScheduleId() {
            return this.$route.params.loanScheduleId
        },
        commentsData() {
            if (this.loan_schedule!=null) {
                return {
                    pageQueryId: this.selectedLoanScheduleId,
                    pageItemCreatedBy: this.loan_schedule.userId,
                    pageLink: this.$router.currentRoute.path.replace('/loans/','/myloans/'), //should send to owner link
                    pageKey: pageKeys.loans,
                    notificationTypeId: notificationTypes.loan_payment_schedule
                }
            }
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        isMobile() {
            return window.innerWidth < 600
        },
        processed_status() {
            if (this.loan_schedule!=null) return this.loan_schedule.status==commonfn.getStatusCode('Processed')
        },
        paid_status() {
            if (this.loan_schedule!=null) return this.loan_schedule.status==commonfn.getStatusCode('Paid')
        },
        disabledForApprover() {
            return this.paid_status
        }
    }
}
</script>